import type { DispositionVerdict } from "../../hooks/useStudyQueries";
import type { FindingReason } from "../../hooks/useReviewerFindingVerdicts";

export const OVERALL_VERDICTS: { value: DispositionVerdict; label: string; active: string }[] = [
  {
    value: "right",
    label: "Right",
    active: "bg-signal-tint text-signal-text-tint border-signal-stroke",
  },
  {
    value: "wrong",
    label: "Wrong",
    active: "bg-signal-tint text-signal-text-tint border-signal-stroke",
  },
  {
    value: "borderline",
    label: "Borderline",
    active: "bg-signal-tint text-signal-text-tint border-signal-stroke",
  },
];

export const REASONS: { value: FindingReason; label: string }[] = [
  { value: "incorrect_anatomy", label: "Incorrect anatomy" },
  { value: "wrong_severity", label: "Wrong severity" },
  { value: "artifact", label: "Artifact" },
  { value: "below_threshold", label: "Below threshold" },
  { value: "other", label: "Other…" },
];
